import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TheHeader from "../comm/inCar/TheHeader";
import TheNav from "../comm/inCar/TheNav";
import TheFooter from "../comm/inCar/TheFooter";
import { setAddrInfo, setReqTaskInfo, setGrpBrNo, setBrNo } from "src/modules/insert";
import {
  CButton,
  CRow,
  CFormGroup,
  CCol,
  CCardBody,
  CInputRadio,
  CLabel,
  CSelect,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput,
  CContainer,
} from "@coreui/react";
import DaumPostCode from "react-daum-postcode";
import ApiHelper from "src/utils/api/api_helper";
import Swal from "sweetalert";
import { useHistory, useLocation } from "react-router-dom";

const InsertPage = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const pathParam = Number(useLocation().pathname.substr(-1, 1));
  const [showPopup, setShowPopup] = React.useState(false);
  const [searchBrInfo, setSearchBrInfo] = React.useState([]);
  const [initData, setInitData] = React.useState({
    bgBrList:[],
    buBrList: [],
    brList: [],
    bankList: [],
    emalDmnList: [],
  });
  const param = { 
    corpNo: state.main.corpNo,
    taskNo: state.main.taskNo,
  };
  // 주민번호 확인 팝업
	const [isCheckJumin, setIsCheckJumin] = React.useState(false);
  // 국적 한국 선택 여부
	const [isKR, setIsKR] = React.useState('');

  function openPopup() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    setShowPopup(true);
  }
  async function closePopup() {
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
    await setSearchBrInfo([]);
    await setShowPopup(false);
  }

  const handleInputChange = async (e) => {
    const targetName = e.target.name;
    const regExpKor = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g;
    const regKor = /[a-zA-Z0-9]/g;
    const regExpNum = /[^0-9]/g;
    let changeData = {};
    let originVal = e.target.value;
    let val = "";

    switch (targetName) {
      case "resRegNoBack":
        setIsCheckJumin(false);
        val = originVal.replace(regExpNum, "");
        break;
      case "resRegNoFront":
        val = originVal.replace(regExpNum, "");
        break;
      // case "actNo":
      //   val = originVal.replace(regExpNum, "");
      //   break;
      case "recrTel":
        val = originVal.replace(regExpNum, "");
        val = val.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,"$1-$2-$3").replace("--", "-");
        break;
      case "emalAddr":
        if(regExpKor.test(originVal)) return Swal("", "이메일주소는 영문과 숫자만 입력가능합니다.", "info").then(() => {document.getElementById('emalAddr').focus()});;
        val = originVal.replace(regExpKor, "");
        break;
      case "emalDmn":
        if(regExpKor.test(originVal)) return Swal("", "이메일도메인은 영문과 숫자만 입력가능합니다.", "info").then(() => {document.getElementById('emalDmn').focus()});;
        val = originVal.replace(regExpKor, "");
        break;
      case "recrEmpNo":
        if (regExpKor.test(originVal))
          return Swal(
            "",
            "유치자사번은 영문과 숫자만 입력가능합니다.",
            "info"
          ).then(() => {
            document.getElementById("recrEmpNo").focus();
          });
        val = originVal.replace(regExpKor, "");
        break;
      case "recrNm":
        if (regKor.test(originVal))
          return Swal(
            "",
            "유치자명은 한글만 입력가능합니다.", 
            "info"
            ).then(() => {
              document.getElementById("recrNm").focus();
          });
        val = originVal.replace(regKor, "");
        break;
      case "natlNm":
        if(originVal == '한국'){
          setIsKR('true');
          val = originVal;
        } else if(originVal == '기타'){
          setIsKR('false');
          val = '';
        } else {
          val = originVal;
        }
        break;
      default:
        val = originVal;
        break;
    }

    changeData = { [e.target.name]: val };

    await dispatch(setReqTaskInfo(changeData, false));

    if (e.target.name === "buBrNo") {
      await dispatch(setReqTaskInfo({ brNo: "" }, false));
    }else if(e.target.name === "bgBrNo"){
      await dispatch(setReqTaskInfo({ brNo: "" , buBrNo: ""}, false));
    }
  };

  const handleEmalDmnChange = (e) => {
    let changeEmalDmnData = {};
    changeEmalDmnData = { emalDmn: e.target.value };
    dispatch(setReqTaskInfo(changeEmalDmnData, false));
  };

  function handleOpenSearchBrNm(e) {
    const { value } = document.getElementById('brNm');
    let params = {};

    params.brNm = value;
    params.corpNo = state.main.corpNo;

    if(value.length < 2) return Swal('협회등록지점 검색', '2자 이상 입력하세요.', 'info');

    ApiHelper.request(
      ApiHelper.methods.get,
      "/cust/request/search-br-nm",
      params
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          const result = data.data;

          setSearchBrInfo(result);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async function applyBrNm() {
    document.getElementsByTagName("body")[0].style.overflow = "scroll";

    const target = document.querySelector('input[name="qualificationYn"]:checked');
    const { grpBrNo } = target.dataset;
    const brNo = target.value;

    await dispatch(setGrpBrNo(grpBrNo));
    await dispatch(setBrNo(brNo));
    await setShowPopup(false);
    await setSearchBrInfo([]);
  }

  // // 주민번호 유효성체크 추가
  // function juminCheck() {
  //   let jumin;
  //   jumin = state.insert.reqTaskInfo.resRegNoFront + state.insert.reqTaskInfo.resRegNoBack
  //   jumin = jumin.split(''); // 주민등록번호를 한자리씩 쪼개서 배열에 담기

  //   let ckarr = [2,3,4,5,6,7,8,9,2,3,4,5]; // 곱해줄 숫자 배열

  //   // 마지막자리 제외하고 각 자리에 ckarr값을 곱해줌
  //   for(let i=0; i<jumin.length-1; i++){
  //       jumin[i] = jumin[i] * ckarr[i];
  //   }
  //   let juminlast = jumin[jumin.length-1]; // 주민등록번호 마지막자리 따로 빼두기

  //   // 각 자리의 숫자를 모두 더하기
  //   let sum = 0;
  //   for(let i=0; i<jumin.length-1; i++){
  //       sum += jumin[i];
  //   }

  //   // 11로 나눈 나머지 값을 구하기
  //   sum = sum % 11;

  //   // 11에서 결과값 빼기
  //   sum = 11 - sum;
  //   // 마지막 결과가 두자리인 경우 다시 10으로 나눈 나머지 값을 구함
  //   if(sum > 9){
  //       sum = sum % 10;
  //   }
    
  //   // 결과가 주민등록번호 마지막 자리와 일치하면 유효한 주민등록번호
  //   // 주민번호 일치
  //   if(sum == juminlast){
  //     return 'same';
  //   }
  //   // 주민번호 불일치
  //   if(sum != juminlast && juminlast != undefined){ 
  //     return 'notsame';
        
  //   }
  // }

   // 주민번호 유효성체크 추가
   function juminCheck() {
    let jumin;
    jumin = state.insert.reqTaskInfo.resRegNoFront + state.insert.reqTaskInfo.resRegNoBack
    // jumin = jumin.split(''); // 주민등록번호를 한자리씩 쪼개서 배열에 담기
    if( jumin.length !== 13 ) return false;

    let checkFrnNo = jumin.substr(6, 1); // 내국인 외국인 확인용 주민번호 7번째 자리
    
    // 검증값 합계
    var checkSum = 0;
    for(var i=0; i<12; i++) checkSum += ((jumin.substr(i,1)>>0)*((i%8)+2));
  
    // 검증
    var modCheckSum = checkSum%11;    // 검증값 합계의 11의 나머지수
    var rrnMatch = ((11-(modCheckSum))%10 == jumin.substr(12,1));    // 주민번호 검증
    var frnMatch = ((13-(modCheckSum))%10 == jumin.substr(12,1));    // 외국인번호 검증

    // 결과가 주민등록번호 마지막 자리와 일치하면 유효한 주민등록번호
    // 주민번호 일치
    if(rrnMatch || frnMatch){
      return 'same';
    } else {
      return 'notsame';
    }
  }

  const handleFillInInfo = (e, nextPage) => {
    let params = {};

    if (nextPage) {
      if (state.insert.reqTaskInfo.brNo === "")
        return Swal("정보입력", "협회등록지점은 필수항목입니다", "error");
      if (state.insert.reqTaskInfo.resRegNoBack.trim().length < 7)
        return Swal(
          "정보입력",
          "주민등록번호 뒤 7자리는 필수항목입니다",
          "error"
        );
      if(juminCheck() === 'notsame')
        return Swal(
          "정보입력",
          "유효하지 않은 주민등록번호입니다.\n 다시 한 번 확인해주세요.",
          "error"
          );
      if (state.insert.reqTaskInfo.addr.trim() === "")
      return Swal("정보입력", "주소는 필수항목입니다", "error");
      if(param.taskNo == '52' || param.taskNo == '53'){
        if (state.insert.reqTaskInfo.emalAddr.trim() === "")
          return Swal("정보입력", "이메일주소는 필수항목입니다", "error");
        if (state.insert.reqTaskInfo.emalDmn.trim() === "")
          return Swal("정보입력", "이메일도메인은 필수항목입니다", "error");
      }
      // #15808 유치자정보 필수 -> 선택 변경
      // if(state.insert.reqTaskInfo.recrNm == ''){
      //   return Swal("정보입력", "유치자명은 필수항목입니다", "error");
      // }
      // if(state.insert.reqTaskInfo.recrTel == ''){
      //   return Swal("정보입력", "유치자연락처는 필수항목입니다", "error");
      // }
      // if(state.insert.reqTaskInfo.recrOflv == ''){
      //   return Swal("정보입력", "유치자직위는 필수항목입니다", "error");
      // }
      // if(state.insert.reqTaskInfo.recrEmpNo == ''){
      //   return Swal("정보입력", "유치자사번은 필수항목입니다", "error");
      // }
      if(state.insert.reqTaskInfo.natlNm == ''){
        return Swal("정보입력", "국적은 필수항목입니다", "error");
      }
      // if (state.insert.reqTaskInfo.bankCd === "")
      //   return Swal("정보입력", "은행은 필수항목입니다", "error");
      // if (state.insert.reqTaskInfo.actNo.trim() === "")
      //   return Swal("정보입력", "계좌번호는 필수항목입니다", "error");

      // 주민번호 확인 팝업
      if (!isCheckJumin){
        setIsCheckJumin(true);
        return Swal(state.insert.reqTaskInfo.resRegNoFront + "-" + state.insert.reqTaskInfo.resRegNoBack, "입력하신 주민번호가 맞는지 한 번 더 확인해주세요.", "info");
      }
    }

    params = state.insert.reqTaskInfo;
    params.corpNo = state.main.corpNo;
    params.qlfcYn = state.main.qualificationYn;
    params.crerYn = state.main.crerYn;
    // 생손보 구분값 추가
    params.lifeQlfcYn = state.main.lifeQualificationYn;
    params.fireQlfcYn = state.main.fireQualificationYn;
    params.lifeCrerYn = state.main.lifeCrerYn;
    params.fireCrerYn = state.main.fireCrerYn;
    // 메리츠 전속 여부
    params.exclYn = state.main.exclYn;

    // 임시저장 여부
    params.tempYn = nextPage;

    if(state.main.qualificationYn == '' || state.main.qualificationYn == undefined || state.main.qualificationYn == null){
      return Swal("유자격자 확인", "메인화면으로 돌아가 유자격자 여부를 선택해주세요", "error");
    } else if(state.main.crerYn == '' || state.main.crerYn == undefined || state.main.crerYn == null){
      return Swal("경력 확인", "메인화면으로 돌아가 경력 여부를 선택해주세요", "error");
    }

    if(state.main.fireCrerYn == '1'){
      if(state.main.exclYn == '' || state.main.exclYn == undefined || state.main.exclYn == null){
        return Swal('메리츠 전속 확인', '메인화면으로 돌아가 전속 여부를 선택해주세요.', 'error');
      }
    }

    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/tempSaveStep3",
      params
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          if (nextPage) {
            history.push(`/${state.main.corpNm}/${pathParam + 1}`);
          } else {
            return Swal("", "임시저장 되었습니다.", "success");
          }
        }else if(data.status === 'INVALID'){
          return Swal("주민등록번호", data.msg, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getInitData = async () => {
    const _initData = Object.assign({}, initData);

    await ApiHelper.request(ApiHelper.methods.get, "/code/commcd/CM105")
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.bankList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    await ApiHelper.request(ApiHelper.methods.get, "/code/commcd/CM103")
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.emalDmnList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/bgBrList",
        param
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;
            _initData.bgBrList = result;
          }
        })
        .catch((err) => {
          console.error(err);
        });  

    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/buBrList",
      param
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.buBrList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/getBrList",
      param
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          _initData.brList = result;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    await setInitData(_initData);
  };

  // [ Start ]주소검색 로직
  const [isAddr, setIsAddr] = React.useState(false);
  const handleOpenPost = () => {
    setIsAddr(!isAddr);
  };

  // postcode
  const handleAddress = (data) => {
    let zoneCode = data.zonecode;
    let AllAddress = data.roadAddress;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      AllAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }

    dispatch(setAddrInfo({ addr: AllAddress, postNo: zoneCode }));
  };
  // [ End ]주소검색 로직

  React.useEffect(() => {
    getInitData();
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={state.main.step} />
        <CContainer>
          <h5>
            <b>
              보험사별 위촉서류 작성을 위한 정보를 입력합니다.
            </b>
          </h5>
        </CContainer>
        <CCardBody className="bottom-card-body">
          <div className="insertTitle">
            <CCol xs="12">
              <h6>본인정보</h6>
            </CCol>
          </div>
          <CRow>
          <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>사업부
              </CLabel>
              <CSelect 
                custom
                name="bgBrNo"
                id="bgBrNo"
                value={state.insert.reqTaskInfo.bgBrNo || ""}
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                <option value="">선택</option>
                {initData.bgBrList.map((bgBr) => (
                  <option key={bgBr.BR_NO} value={`${bgBr.BR_NO}`}>
                    {bgBr.BR_NM}
                  </option>
                ))}
              </CSelect>
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>본부
              </CLabel>
              <CSelect 
                custom
                name="buBrNo"
                id="buBrNo"
                value={state.insert.reqTaskInfo.buBrNo || ""}
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                <option value="">선택</option>
                {initData.buBrList.map((buBr) => (
                  Number(state.insert.reqTaskInfo.bgBrNo) === Number(buBr.UPPR_GRP_NO) &&
                  <option key={buBr.BR_NO} value={`${buBr.BR_NO}`}>
                    {buBr.BR_NM}
                  </option>
                ))}
              </CSelect>
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>
                협회등록지점
              </CLabel>
              <CButton
                type="button"
                color="primary"
                size="sm"
                className="brSearchBtn"
                onClick={openPopup}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                지점명 검색
              </CButton>
              <CSelect
                custom
                name="brNo"
                id="brNo"
                value={state.insert.reqTaskInfo.brNo || ""}
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                <option value="">선택</option>
                {initData.brList.map(
                  (br) =>
                    Number(br.GRP_BR_NO) ===
                      Number(state.insert.reqTaskInfo.buBrNo) && (
                        <option
                        key={br.BR_NO}
                        data-bu-br-no={br.GRP_BR_NO}
                        value={`${br.BR_NO}`}
                      >
                        {br.BR_NM}
                      </option>
                    )
                )}
              </CSelect>
            </CCol>
          </CRow>
          <CRow>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>이름
              </CLabel>
              <CInput
                type="text"
                id="name"
                name="name"
                defaultValue={state.insert.reqTaskInfo.name || ""}
                disabled
              />
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>휴대전화번호
              </CLabel>
              <CInput
                type="text"
                id="hphnNo"
                name="hphnNo"
                defaultValue={state.insert.reqTaskInfo.hphnNo || ""}
                disabled
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol xs="12" className="text-left">
              <CLabel>
                <span>*</span>주민등록번호
              </CLabel>
            </CCol>
            <CCol xs="5" className="mb-2 notPaddingRight">
              <CInput
                type="text"
                id="resRegNoFront"
                name="resRegNoFront"
                value={state.insert.reqTaskInfo.resRegNoFront || ""}
                maxLength="6"
                disabled
              />
            </CCol>
            <CCol xs="7" className="mb-2 notPaddingLeft">
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText className="prependText">-</CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="text"
                  id="resRegNoBack"
                  name="resRegNoBack"
                  placeholder="뒤 7자리"
                  value={state.insert.reqTaskInfo.resRegNoBack || ""}
                  maxLength="7"
                  onChange={handleInputChange}
                  disabled={
                    state.insert.reqTaskInfo.stCd === "10" ||
                    
                    state.insert.reqTaskInfo.stCd === "99"
                      ? false
                      : true
                  }
                />
              </CInputGroup>
            </CCol>
          </CRow>
          <CRow>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>생년월일
              </CLabel>
              <CInput
                type="date"
                id="bdt"
                name="bdt"
                value={state.insert.reqTaskInfo.bdt || ""}
                max="9999-12-31"
                disabled
              />
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>국적
              </CLabel>
              <CCol>
                <CFormGroup variant="custom-radio" inline style={{height:"35px", alignItems:"center"}}>
                  <CInputRadio
                    custom
                    id="natlNm_kr"
                    name="natlNm"
                    value="한국"
                    checked={
                      (state.insert.reqTaskInfo.natlNm === "한국" || isKR == 'true') ? true : false
                    }
                    onChange={handleInputChange}
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  />
                  <CLabel variant="custom-checkbox" htmlFor="natlNm_kr">
                    한국
                  </CLabel>
                </CFormGroup>
                <CFormGroup variant="custom-radio" inline>
                  <CInputRadio
                    custom
                    id="natlNm_etc"
                    name="natlNm"
                    value="기타"
                    checked={
                      ((state.insert.reqTaskInfo.natlNm !== "한국" && state.insert.reqTaskInfo.natlNm !== '') || isKR == 'false') ? true : false
                    }
                    onChange={handleInputChange}
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  />
                  <CLabel variant="custom-checkbox" htmlFor="natlNm_etc">
                    기타
                  </CLabel>
                </CFormGroup>
                {((state.insert.reqTaskInfo.natlNm !== "한국" && state.insert.reqTaskInfo.natlNm !=='') || isKR == 'false') &&
                  <CInput
                    style={{width:"55%", display:"inline-block"}}
                    type="text"
                    id="natlNm"
                    name="natlNm"
                    placeholder="국가명"
                    value={state.insert.reqTaskInfo.natlNm !== "한국" && state.insert.reqTaskInfo.natlNm || ""}
                    onChange={handleInputChange}
                    maxLength="50"
                    disabled={
                      state.insert.reqTaskInfo.stCd === "10" ||
                      
                      state.insert.reqTaskInfo.stCd === "99"
                        ? false
                        : true
                    }
                  />
                }
              </CCol>
            </CCol>
            {/* 메인페이지 팝업으로 변경 */}
            {/* <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>신입/경력
              </CLabel>
              <CCol>
                <CFormGroup variant="custom-radio" inline>
                  <CInputRadio
                    custom
                    id="crerN"
                    name="crerYn"
                    value="0"
                    checked={
                      state.insert.reqTaskInfo.crerYn === "0" ? true : false
                    }
                    onChange={handleInputChange}
                  />
                  <CLabel variant="custom-checkbox" htmlFor="crerN">
                    신입
                  </CLabel>
                </CFormGroup>
                <CFormGroup variant="custom-radio" inline>
                  <CInputRadio
                    custom
                    id="crerY"
                    name="crerYn"
                    value="1"
                    checked={
                      state.insert.reqTaskInfo.crerYn === "1" ? true : false
                    }
                    onChange={handleInputChange}
                  />
                  <CLabel variant="custom-checkbox" htmlFor="crerY">
                    경력
                  </CLabel>
                </CFormGroup>
              </CCol>
            </CCol> */}
          </CRow>
          <CRow>
            <CCol xs="12" className="text-left">
              <CLabel>
                <span>*</span>자택주소
              </CLabel>
            </CCol>
            <CCol xs="6">
              <CInput
                type="text"
                id="zoneCode"
                name="postNo"
                value={state.insert.reqTaskInfo.postNo || ""}
                onChange={handleInputChange}
                disabled
              />
            </CCol>
            <CCol xs="6" className="text-left">
              <CButton
                type="button"
                color="primary"
                onClick={handleOpenPost}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                검색
              </CButton>
            </CCol>
            {isAddr ? (
              <CCol xs="12">
                <DaumPostCode
                  onComplete={handleAddress}
                  autoClose
                  // theme={themeObj}
                />
              </CCol>
            ) : null}
            <CCol xs="12" className="mb-2">
              <CLabel></CLabel>
              <CInput
                type="text"
                id="fullAddress"
                name="addr"
                value={state.insert.reqTaskInfo.addr || ""}
                onChange={handleInputChange}
                disabled
              />
              <CLabel></CLabel>
              <CInput
                type="text"
                id="dtlAddr"
                name="dtlAddr"
                placeholder="상세주소"
                value={state.insert.reqTaskInfo.dtlAddr || ""}
                onChange={handleInputChange}
                maxLength="200"
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
          </CRow>
          { (param.taskNo == '52' || param.taskNo == '53') &&
          <CRow>
            <CCol xs="12" className="text-left">
              <CLabel>
                <span>*</span>이메일
              </CLabel>
            </CCol>
            <CCol xs="6" className="mb-2 notPaddingRight">
              <CInput
                type="text"
                id="emalAddr"
                name="emalAddr"
                placeholder="이메일주소"
                value={state.insert.reqTaskInfo.emalAddr || ""}
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
            <CCol xs="6" className="mb-2 notPaddingLeft">
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText className="prependText">@</CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  type="text"
                  id="emalDmn"
                  name="emalDmn"
                  placeholder="도메인"
                  value={state.insert.reqTaskInfo.emalDmn || ""}
                  onChange={handleInputChange}
                  disabled={
                    state.insert.reqTaskInfo.stCd === "10" ||
                    
                    state.insert.reqTaskInfo.stCd === "99"
                      ? false
                      : true
                  }
                />
              </CInputGroup>
            </CCol>
            <CCol xs="6" className="mb-2"></CCol>
            <CCol xs="6" className="mb-2 notPaddingLeft">
              <CSelect
                custom
                name="selEmalDmn"
                id="selEmalDmn"
                value={state.insert.reqTaskInfo.emalDmn || ""}
                onChange={handleEmalDmnChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                <option value="">직접입력</option>
                {initData.emalDmnList.map((emalDmn, index) => {
                  return index === 0 ? undefined : (
                    <option key={emalDmn.DTL_CD} value={emalDmn.CD_NM}>
                      {emalDmn.CD_NM}
                    </option>
                  );
                })}
              </CSelect>
            </CCol>
          </CRow>
          }
          {/* <CRow>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>은행
              </CLabel>
              <CSelect
                custom
                name="bankCd"
                id="bankCd"
                value={state.insert.reqTaskInfo.bankCd || ""}
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              >
                <option value="">선택</option>
                {initData.bankList.map((bank) => (
                  <option key={bank.DTL_CD} value={bank.DTL_CD}>
                    {bank.CD_NM}
                  </option>
                ))}
              </CSelect>
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span>*</span>계좌번호
              </CLabel>
              <CInput
                type="text"
                id="actNo"
                name="actNo"
                placeholder="숫자만입력"
                value={state.insert.reqTaskInfo.actNo || ""}
                maxLength="20"
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol xs="12" className="text-left mb-2">
              <CLabel>
                <span>*</span>예금주&nbsp;&nbsp;
                <small>본인명의의 계좌만 가능합니다.</small>
              </CLabel>
              <CInput
                type="text"
                id="actNm"
                name="actNm"
                defaultValue={state.insert.reqTaskInfo.actNm || ""}
                disabled
              />
            </CCol>
          </CRow> */}
          <CRow>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span></span>유치자명
              </CLabel>
              <CInput
                type="text"
                id="recrNm"
                name="recrNm"
                value={state.insert.reqTaskInfo.recrNm || ""}
                maxLength="25"
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span></span>유치자연락처
              </CLabel>
              <CInput
                type="text"
                id="recrTel"
                name="recrTel"
                value={state.insert.reqTaskInfo.recrTel || ""}
                maxLength="13"
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span></span>유치자직위
              </CLabel>
              <CInput
                type="text"
                id="recrOflv"
                name="recrOflv"
                value={state.insert.reqTaskInfo.recrOflv || ""}
                maxLength="10"
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
            <CCol xs="12" md="6" className="text-left mb-2">
              <CLabel>
                <span></span>유치자사번
              </CLabel>
              <CInput
                type="text"
                id="recrEmpNo"
                name="recrEmpNo"
                value={state.insert.reqTaskInfo.recrEmpNo || ""}
                maxLength="20"
                onChange={handleInputChange}
                disabled={
                  state.insert.reqTaskInfo.stCd === "10" ||
                  state.insert.reqTaskInfo.stCd === "99"
                    ? false
                    : true
                }
              />
            </CCol>
          </CRow>
        </CCardBody>
        {showPopup &&
          <div className="layer-popup">
            <div className="box-popup popup-sign">
              <button
                className="popup-close"
                onClick={closePopup}
                type="button"
              >
                {' '}
              </button>
              <div className="popup-title">협회등록지점 검색</div>
              <div className="popup-contents">
                <span className="txt-label">검색 시 2자이상 입력해야 합니다.</span>
                <CRow>
                  <CCol xs="8" className="mt-4 mb-2">
                    <CInput
                      type="text"
                      id="brNm"
                      name="brNm"
                    />
                  </CCol>
                  <CCol xs="4" className="mt-4 mb-2">
                    <CButton
                      type="button"
                      color="primary"
                      onClick={handleOpenSearchBrNm}
                      >
                      검색
                    </CButton>
                  </CCol>
                </CRow>
                <fieldset className="search-fileset">
                { searchBrInfo.length > 0 
                ? searchBrInfo.map((item) =>{
                    return (
                      <CRow key={item.BR_NO}>
                        <CCol xs="12" className="ml-10 mb-2 mt-2">
                            <label className="component-radio type-default">
                              <input type="radio" name="qualificationYn" data-grp-br-no={item.GRP_BR_NO} value={item.BR_NO} />
                              <i />
                              <div className="text-label">{item.BR_NM}</div>
                            </label>
                        </CCol>
                      </CRow>
                    )
                  })
                  : <span>검색해 주세요.</span>
                }
                </fieldset>
              </div>
              <div className="popup-footer">
                <button className="btn-footer" type="button" onClick={() => closePopup()}>
                  닫기
                </button>
                <button className="btn-footer type-solid" type="button" onClick={applyBrNm}>
                  확인
                </button>
              </div>
            </div>
          </div>
        }
        </div>
      <TheFooter step={state.main.step} handleFillInInfo={handleFillInInfo} />
    </>
  );
};

export default InsertPage;
